import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCurrentUser, useAccessToken } from '@/features/auth/state/auth'
import { useToast } from '@/lib/hooks/use-toast'
import api, { withAuthenticatedRequest } from '@/lib/api'
import { AxiosError } from 'axios'

interface UpdateStatusParams {
  id: string
  typeCargo: string
}

export function useUpdateUserCargo({ onSuccess }: { onSuccess: () => void }) {
  const queryClient = useQueryClient()
  const user = useCurrentUser()
  const token = useAccessToken()
  const { toast } = useToast()
  return useMutation({
    mutationFn: async ({ id, typeCargo }: UpdateStatusParams) => {
      if (!user || !token) throw new Error('Usuário ou token ausente')
      if (!id) throw new Error('ID do usuário para alterar ausente')

      await api.patch(
        `/user/cargo`,
        {
          typeCargo,
          id
        },
        withAuthenticatedRequest(token)
      )
    },
    onSuccess: () => {
      onSuccess()
      queryClient.refetchQueries({ queryKey: ['user'] })
      queryClient.refetchQueries({ queryKey: ['gerente'] })
      toast({
        title: 'Sucesso',
        description: 'Cargo do usuário atualizado com sucesso!'
      })
    },
    onError: (error: unknown) => {
      let message = ''

      if (error instanceof Error) message = error.message
      if (error instanceof AxiosError) {
        switch (error.response?.status) {
          case 404:
            message = 'Usuário não encontrado'
            break
          default:
            message = 'Erro desconhecido'
        }
      }

      toast({
        title: 'Erro',
        description: `Erro ao atualizar o status do usuário: ${message}`,
        variant: 'destructive'
      })
    }
  })
}
